import type { FC } from 'react';

interface AccountDetailsProps {}

const AccountDetails: FC<AccountDetailsProps> = () => {
  return <div>account details</div>;
};

export default AccountDetails;
